import { IDiagram, IPaginatedREST } from '../types'
import { BOWTIE_BASE_URL, BOWTIE_REST_ENDPOINTS } from '../utils/constants'

export interface IDiagramCreateDTO {
    hazard: {
        name: string
        operation: {
            id: number
        }
    }
    topEvent: {
        name: string
    }
}

export interface IDiagramsListFilters {
    /** Number of items per page */
    perPage?: number
    /** Page to request page start in 1 */
    page?: number
    /** string to search */
    keyword?: string
    direction?: 'ASC' | 'DESC'
    orderBy?: string
    operation?: number
}

export const listDiagrams = async (params?: IDiagramsListFilters): Promise<IPaginatedREST<IDiagram>> => {
    const qs = new URLSearchParams({
        limit: params?.perPage?.toString() ?? '',
        offset: ((params?.page ?? 1) - 1)?.toString() ?? '',
        keyword: params?.keyword ?? '',
        direction: params?.direction ?? '',
        orderBy: params?.orderBy?.toUpperCase() ?? '',
        operation: params?.operation?.toString() ?? ''
    }).toString()

    return fetch(`${BOWTIE_BASE_URL}/${BOWTIE_REST_ENDPOINTS.diagrams}/?${qs}`, {
        method: 'GET',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' }
    }).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = undefined
        }

        if (data.ok) {
            return jsonData
        } else {
            throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message)
        }
    })
}

export const getDiagrams = async (id: number): Promise<IDiagram> => {
    if (!id) {
        return undefined
    }

    return fetch(`${BOWTIE_BASE_URL}/${BOWTIE_REST_ENDPOINTS.diagrams}/${id}`, {
        method: 'GET',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' }
    }).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = undefined
        }

        if (data.ok) {
            return jsonData
        } else {
            throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message)
        }
    })
}

export const createDiagram = async (body: IDiagramCreateDTO): Promise<IDiagram> => {
    return fetch(`${BOWTIE_BASE_URL}/${BOWTIE_REST_ENDPOINTS.diagrams}/`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
    }).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = undefined
        }

        if (data.ok) {
            return jsonData
        } else {
            throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message)
        }
    })
}

export const updateDiagram = async (body: IDiagram): Promise<IDiagram> => {
    return fetch(`${BOWTIE_BASE_URL}/${BOWTIE_REST_ENDPOINTS.diagrams}/`, {
        method: 'PATCH',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
    }).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = undefined
        }

        if (data.ok) {
            return jsonData
        } else {
            throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message)
        }
    })
}

export const deleteDiagram = async (id: number): Promise<void> => {
    return fetch(`${BOWTIE_BASE_URL}/${BOWTIE_REST_ENDPOINTS.diagrams}/${id}`, {
        method: 'DELETE',
        credentials: 'same-origin'
    }).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = undefined
        }

        if (data.ok) {
            return jsonData
        } else {
            throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message)
        }
    })
}
